// Voice swiper (TOP「生徒・保護者の声」). Requires Swiper to be loaded (from CDN or bundled).
// Targets .js-voiceSwiper, with .swiper-button-next / .swiper-button-prev (arrows only, no dots per Figma).
// 横100%（full-bleed）: コンテナを画面幅に広げ、カードは Figma 実寸固定（PC600 / SP310・SCSS側）。
// slidesPerView:auto + 固定幅カードで「PC 約2枚＋覗き / SP 1枚＋覗き」を自然に再現（centered は不使用＝S-03-16-S）。
// 1枚目カード左端はコンテナの padding-left（SCSS・コンテンツ左マージン）でちょうど見出し左に揃える（パターンA：左揃え・右ブリード）。
//   ※ loop を使うと先頭にクローンが挿入され左マージンに覗きが出てしまうため loop:false。
//     これにより padding-left 領域は空のまま＝1枚目が左マージンに flush。右はカードが画面端まで流れ overflow:hidden でクリップ。
// spaceBetween 12 (Figma gap)。矢印ナビのみ（ドット無し）。末尾で next は自動 disabled。
export function initVoiceSwiper() {
  const el = document.querySelector('.js-voiceSwiper');
  if (!el || typeof Swiper === 'undefined') return;

  return new Swiper(el, {
    speed: 600,
    loop: true,
    spaceBetween: 40,
    slidesPerView: 1,
    centeredSlides: true,
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
      769: {
        slidesPerView: 'auto',
        spaceBetween: 64,
      },
    },
  });
}
